/**
 * Created by zhaoyao on 2021/6/3
 * Desc: 相册订购
 */

import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Avatar } from 'antd'
import { Toast } from 'antd-mobile'
import { getSearchParams, isObjEmpty } from '../../../utils/common'
import './AlbumPay.css'
import { fetchGet, fetchPost } from '../../../utils/fetchRequest'
import { API } from '../../../configs/api.config'
import {switchUser} from 'action/userInfo'

class AlbumPay extends Component {

  constructor (props) {
    super(props)

    this.state = {
      id: this.props.match.params.id,
      appId: this.props.match.params.appId,
      openId: this.props.match.params.openId,
      balance: '0',
      payment: '0',
      createDate: '',
      rechargeList: [],
      errorMsg: '',
    }
  }

  componentDidMount () {
    document.title = '相册订购'

    Toast.loading('', 0)
    this.getServiceList()
  }

  componentWillUnmount () {
    Toast.hide()
  }

  render () {
    const { balance, payment, createDate, rechargeList, } = this.state

    const rechargeItems = []
    rechargeList.forEach((rechargeObj, index) => {

        rechargeItems.push(<div>
            <div className='service-content-layout'>
                <div className='service-content-item'
                onClick={this.onRechargeClick.bind(this, index,
                    rechargeObj.id)}>
                    <span className='service-content-item-text'>{rechargeObj.mode==0?'精选相册':'普通相册'}</span>
                    <span className='service-content-item-text'>¥ {rechargeObj.paymoney}</span>
                </div>
            </div>
            <div>
                <div className="span_15 text_bold">相册介绍:</div>
                <div className="div-long-text margin_top_10">{rechargeObj.introduce}</div>
            </div>
        </div>
        )
    })

    return (
      <div id='info-service-root'>
        <div id='info-service-body'>

          {/*订购费列表*/}
          <span className='service-content-title'>订购费（元/本）</span>
          <div style={{ marginTop: '6px' }}>{rechargeItems}</div>
        </div>
        <div
            style={{
              textAlign: 'center',
              margin: '2px 10px 20px 0px',
            }}>
            {/*<span style={{
              color: 'blue',
              fontSize: '16px',
              borderBottom: '1px solid blue',
              fontWeight: '600',
            }}
                  onClick={this.toChargeRecord}>历史交费记录</span>*/}
        </div>
      </div>
    )
  }

  getServiceList = () => {
    const { id, rechargeList } = this.state
    rechargeList.length = 0

    fetchGet(API.INFO_ALBUM_SERVICE_LIST, {
      id
    }).then(response => {
      Toast.hide()

      if (response && response.data && response.data.rulesList &&
          response.data.rulesList.length > 0) {
         this.setState({
                   rechargeList: response.data.rulesList,
                 }, () => {
                   console.log(rechargeList)
                 })
        }

    }).catch(error => {
      Toast.hide()

      this.setState({
        rechargeList,
      })
      if (typeof error === 'string') {
        Toast.fail(error, 2)
      } else {
        Toast.fail('请求异常', 2)
      }
    })
  }

  onRechargeClick = (index, rid) => {
    this.wxPayRequest(rid)
  }

  wxPayRequest = (rid) => {
  const {id,appId, openId } = this.state
    let err = ''
    Toast.loading('')

    fetchPost(API.ELECTRONIC_ALBUM_ORDER, {
      appId:appId,
      openId: openId,
      studentId: id,
      rId: rid,
    }).then((response) => {
      Toast.hide()
      const data = response.data
      err = data
      if(err === undefined ){
        err=response.message;
      }
      if (typeof WeixinJSBridge == 'undefined') {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady',
            this.onBridgeReady(data), false)
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady',
            this.onBridgeReady(data))
          document.attachEvent('onWeixinJSBridgeReady',
            this.onBridgeReady(data))
        }
      } else {
        this.onBridgeReady(data)
      }
    }).catch((error) => {
      console.log('error:' + JSON.stringify(error))
      Toast.show('支付失败！' + err)
    })
  }

  onBridgeReady = (json) => {
    console.log('json:', json)
    const that = this
    window.WeixinJSBridge.invoke(
      'getBrandWCPayRequest', JSON.parse(json),
      function (res) {
        if (res.err_msg == 'get_brand_wcpay_request:ok') {
          // 使用以上方式判断前端返回,微信团队郑重提示：
          //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
          Toast.success('支付成功！')
          // that.props.history.push('/payResult/' + that.state.amount)
        } else {
          Toast.fail('支付失败！')
          // message.info("支付失败:" + res.err_msg)
          // that.setState({
          //     payInfo: json,
          //     payResult: "支付失败:" + JSON.stringify(res)
          // });
        }
      })
  }

  toChargeRecord = () => {
    this.props.history.push('/albumDetail')
  }

}

let mapStateToProps = (state) => ({
  userInfo: { ...state.redUserInfo },
  schoolId: state.redUserInfo.user.schoolId,
  stu: state.redUserInfo.parent.student,
  openId: state.redUserInfo.userOpenid,
  stuPhoto: state.redUserInfo.parent.student
    ? state.redUserInfo.parent.student.stuPhoto
    : '',
  stuName: state.redUserInfo.parent.student
    ? state.redUserInfo.parent.student.stuName
    : '',
})

let mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(AlbumPay)
